function getIsLOAJourneyEnabled(configuration) {
  return configuration.app?.solJourney?.loaJourney?.enabled;
}

module.exports = { getIsLOAJourneyEnabled };
